<div class="home-custom-theme">
  <app-home-header *ngIf="!loading"></app-home-header>
  <div class="router-outlet">
    <router-outlet></router-outlet>

    <div class="to-top" (click)="scrollToTop()" [ngClass]="{ 'show-scrollTop': windowScrolled }">
      <img src="assets/img/home/scroll-up-icon.png" alt="to-top-icon" />
    </div>
  </div>
  <app-home-footer *ngIf="!loading"></app-home-footer>
</div>
